export const getAccessToken = (preferredToken) => preferredToken || localStorage.getItem('access_token') || '';

export const buildAuthHeaders = (preferredToken) => {
  const accessToken = getAccessToken(preferredToken);

  return accessToken
    ? { Authorization: `Bearer ${accessToken}` }
    : {};
};